import { Injectable } from "@angular/core";

import { FormlyFieldConfig } from "@ngx-formly/core";

@Injectable({
  providedIn: 'root'
})
export class FormConfigurationParserService {

  findNavTabConfigs = (formConfig: FormlyFieldConfig[]): FormlyFieldConfig[] =>
    formConfig?.[0]?.fieldGroup?.[0]?.fieldGroup;

  findNavTabConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number): FormlyFieldConfig =>
    this.findNavTabConfigs(formConfig)?.filter(navTabConfig => navTabConfig.key === `tab${navTabNumber}`)?.[0];

  findPageConfigs = (formConfig: FormlyFieldConfig[], navTabNumber: number): FormlyFieldConfig[] =>
    this.findNavTabConfig(formConfig, navTabNumber)?.fieldGroup;

  findPageConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number): FormlyFieldConfig =>
    this.findPageConfigs(formConfig, navTabNumber)?.filter(pageConfig => pageConfig.key === `page${pageNumber}`)?.[0];

  findSectionConfigs = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number): FormlyFieldConfig[] => {
    const pageConfig = this.findPageConfig(formConfig, navTabNumber, pageNumber);
    if (pageConfig?.fieldArray != null) {
      return (pageConfig?.fieldArray as FormlyFieldConfig).fieldGroup;
    }
    else {
      return pageConfig?.fieldGroup;
    }
  }

  findSectionConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number, sectionCode: string): FormlyFieldConfig =>
    this.findSectionConfigs(formConfig, navTabNumber, pageNumber)?.filter(sectionConfig => sectionConfig.key === sectionCode)?.[0];

  findQuestionConfigs = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number, sectionCode: string): FormlyFieldConfig[] => {
    const sectionConfig = this.findSectionConfig(formConfig, navTabNumber, pageNumber, sectionCode);
    if (sectionConfig?.fieldArray != null) {
      return (sectionConfig?.fieldArray as FormlyFieldConfig).fieldGroup;
    }
    else {
      return sectionConfig?.fieldGroup;
    }
  }

  findQuestionConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number, sectionCode: string, questionCode: string): FormlyFieldConfig =>
    this.findQuestionConfigs(formConfig, navTabNumber, pageNumber, sectionCode)?.filter(questionConfig => questionConfig.key === questionCode)?.[0];
}
